import { SubtitleBoldTypographyProps } from '../../_components/organisms/CreateNewModalCoreComponent';

const componentConstants = {
  ATOMS: {
    OVERVIEW_CARD_TOOLTIP_COMPONENT: {
      TOTAL: 'Cohort Cost / Total Cost -',
      MEDICAL: 'Cohort Medical / Total Medical -',
      RX: 'Cohort Rx / Total Rx -',
      MEMBERS: 'Cohort Members / Total Members -',
      EMPLOYEES: 'Cohort Employees / Total Employees -',
      DEPENDENTS: 'Cohort Dependents / Total Dependents -',
    },
    COHORT_DETAILS: {
      SELECT: 'Select',
      CATEGORY: 'Category',
      PROPERTY: 'Property',
      SUB_CATEGORY: 'Sub Category',
      AND: 'AND',
      OR: 'OR',
      CONDITION: 'Condition',
      TEXT_FIELD_PLACEHOLDER: 'Enter Numerical Value',
      SAVE: 'Submit',
    },
  },
  MOLECULES: {
    LOADER: {
      LOADING_LABEL_LIST: [
        ['', 'Unlocking the power of Healthcare Data, One byte at a time...'],
        ['Better Health Awaits: ', 'A Moment More for Analytics...'],
        ['Health Data Loading: ', 'A Few Seconds Closer to Better Outcomes...'],
        ['Patience is a Virtue: ', 'A Few More Seconds for Health Insights...'],
        ['Data Deliberation in Progress: ', 'Loading for Better Healthcare...'],
        ['Health Analytics on the Horizon: ', 'Just a Few More Seconds...'],
        ['Data Driven Decisions Ahead: ', 'Loading Healthcare Insights...'],
        ['Patience Pays Off: ', 'Loading Health Analytics Now...'],
        ['', 'Better Health is Just a Load Away...'],
        ['', 'Loading the Key to Better Healthcare Outcomes...'],
        ['Data-Fueled Decisions: ', 'A Moment More for Health Analytics...'],
        ['Making Health Data Work for You: ', 'Loading Insights Now...'],
        ['Bringing Data to Life: ', 'A Few More Seconds for Healthcare...'],
        ['Health Analytics at Your Fingertips: ', 'Loading Soon...'],
        [
          'Transforming Healthcare with Data: ',
          'One Load Closer to Better Outcomes...',
        ],
        ['AI-Powered Health Insights: ', 'Loading for Better Decisions...'],
        [
          'Machine Learning Meets Healthcare: ',
          'A Few More Seconds for Insights...',
        ],
        [
          'Data-Driven Decisions, AI-Enabled: ',
          'Loading Healthcare Analytics...',
        ],
        [
          'Revolutionizing Healthcare with AI and ML: ',
          'Loading Insights Now...',
        ],
        [
          'Health Analytics Evolved: ',
          'A Moment More for AI-Powered Insights...',
        ],
        ['Intelligent Health Insights, Loading Soon...'],
        [
          'Better Health through AI and ML: ',
          'A Few More Seconds for Analytics...',
        ],
        [
          'The Future of Healthcare Analytics: ',
          'Loading AI-Driven Insights...',
        ],
        ['Health Data Meets AI: ', 'Loading for Better Outcomes...'],
        [
          'Unleashing the Power of AI and ML for Healthcare: ',
          'Loading Analytics...',
        ],
      ],
    },
    MEDICAL_HISTORY_TIMELINE: {
      CLAIMS_ID: 'Claims ID',
      PRIMARY_DIAGNOSIS: 'Primary Diagnosis',
      PROVIDER: 'Provider',
      TOTAL_AMOUNT_PAID: 'Total Amount Paid',
      LOAD_MORE: 'Load 10 more',
      MEDICATION: 'Medication',
      AVG_RATE_VS_CMS: 'Avg Rate vs CMS',
      TOTAL_RATE: 'Benchmarked Spend',
    },
    PATIENT_DETAILS_TABS: {
      OVERVIEW: 'Overview',
      MEDICAL_HISTORY: 'Medical History',
      CARE_GAPS: 'Care Gaps',
      CASE_HISTORY: 'Case History',
      CREATE_CASE: 'Create Case',
    },
    PATIENT_DETAILS_OVERVIEW_TAB: {
      ADHERENCE: 'Adherence',
      RAF_SCORE: 'raf Score',
      POLY_PHARMA_INTERACTION: 'Poly Pharma Interaction',
      MEDICAL_MANAGEMENT_REFER: 'Refer to medical management',
      MEDICAL_MANAGEMENT_PORTAL:
        'You can refer to medical management from this portal',
      CASE_MANAGEMENT_REFER: 'Refer to case management',
      CASE_MANAGEMENT_PORTAL:
        'You can refer to case management from this portal',
      ADHERENCE_TOOLTIP:
        'Degree of compliance, in relation to drugs/medications,  with the prescribed treatment plan prescribed by the provider. For example, if a patient is prescribed a medication for a specific duration and follows the prescribed regimen exactly as instructed, their adherence rate would be 100%. However, if they miss doses, take incorrect doses, or prematurely discontinue the medication, their adherence rate would be lower.',
      RAF_SCORE_TOOLTIP: `The risk adjustment factor (RAF) score, in relation to HCC coding, is a numerical value that quantifies the expected healthcare costs based on a patient's health conditions and demographic factors.`,
      //  A RAF score of 1.00 indicates the patient is expected to use an average amount of resources. A score above 1.00 indicates high risk and therefore the patient is expected to use more than the average amount of resources. Conversely, a RAF score below 1.00 indicates low risk and less than average resource consumption is expected. A high RAF score reflects the most complicated patients, the highest consumption of resources, and the highest complexity of care needed. A RAF score is calculated each plan year.`,
      POLY_PHARMA_INTERACTION_TOOLTIP: `Described as a change in the effect of one drug due to the presence of another drug. Most interactions can seriously affect efficacy and safety drug profiles and have been a significant cause of adverse drug interactions (ADRs).\n\n
      <strong>Major:</strong> The interactions are life-threatening and/or require medical treatment or intervention to minimize or prevent severe adverse effects.\n
      <strong>Moderate:</strong>  The interactions may result in exacerbation of the disease of the patient and/or change in therapy.\n
      <strong>Minor:</strong>  The interactions would limit the clinical effects. The manifestations may include an increase in frequency or severity of adverse effects, but usually they do not require changes in therapy.\n
      <strong>Unknown:</strong>  Due to lack of mechanism descriptions in our database, severity classifications of these drug interactions were annotated with 'Unknown'.`,
      EMPTY_TABLE:
        'It is good to know that the member does not have any conditions',
    },
    PATIENT_DETAILS_MEDICAL_HISTORY_TAB: {
      DATE_FORMAT: 'Do MMM[,] YYYY',
      MEDICAL_HISTORY: 'Medical History',
      TIMELINE_VIEW: 'Timeline View',
      CARD_VIEW: 'Card View',
      FITLER: 'Filter',
    },
    PATIENT_DETAILS_CARE_GAPS_TAB: {
      TITLE1: 'System Risk Assessment',
      SUBTITLE1:
        'Evaluating compliance to care quality measures attributed to the performance of system/ health plan',
      TITLE2: 'Self-Imposed Risk Assessment',
      SUBTITLE2:
        'Evaluating compliance to care quality measures attributed to patient',
      COMPLIED: 'Complied',
      NOTCOMPLIED: 'Not Complied',
    },
    TAB_SELECTION: {
      OVERVIEW: 'Overview',
      RECOMMENDATIONS: 'Recommendations',
    },
    NEW_EDIT_DURATION: {
      TITLE: 'Select a start and end date',
      START_DATE: 'Start Date',
      END_DATE: 'End Date',
      YEARLY_INFO:
        'Data is computed annually, please choose dates that are exactly one year apart',
      MONTHLY_INFO:
        'Data is computed monthly, please choose dates that are exactly Zero months - One year apart',
      SUBMIT_DATES: 'Submit Dates',
    },
    CREATE_NEW_USER: {
      TITLE: 'Create New User',
      UPDATE_TITLE: 'Edit User',

      SUBTITLE: 'Fill in the details to add a new user',
      UPDATE_SUBTITLE: 'Fill in the details to edit a new user',

      FIRSTNAME: 'First Name',
      LASTNAME: 'Last Name',
      EMAILID: 'Email ID',
      ACCESS_LEVEL: 'Access Level',
      ROLE: 'Role',
      ORGANIZATION_NAME: 'Organization Name',
      GROUPNO: 'No. of Groups',
      SELECTGROUPS: 'Select Group(s)',
      SELECTFEATURE: 'Select Feature(s)',
      SELECTPLATFORM: 'Select Platform',
      EXTRACTION_METHOD: 'Extraction Method',
      PLACEHOLDER_EXTRACTION_METHOD: 'Select Extraction Method',
      PLACEHOLDER_EMAIL_ID: 'Enter Your Email ID',
      PLACEHOLDER_FIRST_NAME: 'Enter Your First Name',
      PLACEHOLDER_LAST_NAME: 'Enter Your Last Name',
      PLACEHOLDER_ROLE: 'Enter Role',
      PLACEHOLDER_ORGANIZATION_NAME: 'Enter Organization Name',
      PLACEHOLDER_GROUP: 'Groups user can access',
      PLACEHOLDER_RISK: 'Total Members',
      PLACEHOLDER_DOC: 'Total Documents',
      PLACEHOLDER_CASES: 'Total Cases/Month',

      RISK_MANAGEMENT: 'Claims AIQ',
      COMPLIANCE: 'Contracts AIQ',
      CARE_NAVIGATION: 'Care Navigation',

      CANCEL: 'Cancel',
      APPLYALL: 'Apply To All',
      REMOVE: 'Remove',
      NEXT: 'Next',
      ADD_GROUP: 'Add New Group',
      SUBMIT: 'SAVE',
      USER_ROLES: [
        'Administrative Services Only (ASO) Provider',
        'Third-Party Administrator (TPA)',
        'Health Insurance Carrier',
        'Pharmacy Benefit Manager (PBM)',
        'Pharmacy Claims Administrator',
        'Stop-Loss Insurance Provider',
        'Provider Network Access',
        'Reference-Based Pricing (RBP)',
        'Digital Health & Virtual Care Provider',
        'Chronic Disease & Care Management',
        'Point Solution Provider',
        'Broker or Consultant',
        'Specialist Legal & Compliance Consultant',
        'Retirement Plan Provider',
        'Retirement Plan Administrator',
        'Pharmacy Consultant',
        'HR Services',
        'Collective Bargain Group',
        'Custodial Vendor',
        'Direct Contract Provider (or Group)',
        'Dental Benefits Provider',
        'Vision Benefits Provider',
        'Life Insurance Provider',
        'Accident Insurance Provider',
        'Critical Illness Insurance Provider',
        'Pet Insurance Provider',
        'Legal Insurance Provider',
        'Identity Theft Protection Provider',
        'Short-Term Disability',
        'Long-Term Disability',
      ],
      EXTRACTION_METHODS: ['Open Ai', 'Landing Ai'],
    },
    ADD_COHORT_INFO: {
      ADD_COHORTS_INFO:
        'To finetune your data for the selected group(s) add cohorts by ',
      EDIT_COHORTS_INFO:
        'Edit the cohorts you selected previously for the group(s) by ',
      CLICK_HERE: 'clicking here',
      DATA_INFO:
        'Data is computed monthly, please choose dates that are exactly Zero months -one year apart',
    },
  },

  ORGANISMS: {
    SIDENAVBAR: {
      MENU_ITEMS: {
        TABS: [
          ['Experience', false, '/experience'],
          [
            'Analytics Suite',
            true,
            [
              [
                'Disease Management',
                `/dashboard/${encodeURIComponent('Disease Management')}`,
                [
                  ['Disease and Condition Spend', '/disease-prelavence'],
                  ['Chronic Prevalence Analysis', '/chronic-prelavence'],
                  ['Disease Prognosis', '/rising-risk'],
                  ['Care Gaps', '/care-quality'],
                ],
              ],
              [
                'Cost Management',
                `/dashboard/${encodeURIComponent('Cost Management')}`,
                [
                  ['Episodes of Care', '/episodes-of-care'],
                  // ['Waste Calculator', '/waste-calculator'],
                  ['High Cost Claimants', '/high-cost-claims'],
                ],
              ],
              [
                'Stop Loss Management',
                `/dashboard/${encodeURIComponent('Stop Loss Management')}`,
                [
                  ['Stop Loss Aggregate Report', '/stoploss-report'],
                  ['50-50 Report Plan', '/report-plan'],
                  ['Stop Loss Triggers', '/stoploss-triggers'],
                  ['Deductible Corridors', '/specific-deductible-corridors'],
                ],
              ],
              [
                'Plan Analysis',
                `/dashboard/${encodeURIComponent('Plan Analysis')}`,
                [
                  ['Plan Performance', '/plan-performance'],
                  ['Claims Metrics', '/claims-metrics'],
                  ['Enrollment Metrics', '/enrollment-metrics'],
                  ['Network Usage', '/network-leakage'],
                ],
              ],
              [
                'Claims Management',
                `/dashboard/${encodeURIComponent('Claims Management')}`,
                [
                  ['Rejected Claims', '/rejected-claims'],
                  ['Pending Claims', '/pending-claims'],
                ],
              ],
              [
                'Medical Claim Utilization',
                `/dashboard/${encodeURIComponent('Medical Claim Utilization')}`,
                [
                  ['Admission Utilization', '/patient-admission'],
                  ['Procedure Utilization', '/procedure-utilization'],
                  ['Provider Utilization', '/provider-utilization'],
                  ['MedPharma Drug Utilization', '/med-pharma'],
                ],
              ],
              [
                'Drug Utilization',
                `/dashboard/${encodeURIComponent('Drug Utilization')}`,
                [
                  ['Drug Utilization Summary', '/rx-utilization'],
                  ['MedPharma Drug Utilization', '/med-pharma'],
                  ['Specialty Drug Utilization', '/speciality-drugs'],
                  ['Non-Speciality Drug Utilization', '/other-prescription'],
                  ['GLP-1 Drug Utilization', '/glp-drugs'],
                ],
              ],
              [
                'Risk Profile',
                `/dashboard/${encodeURIComponent('Risk Profile')}`,
                [
                  [
                    'Chronic Condition Comorbidity',
                    '/risk-profiling-by-chronic',
                  ],
                  [
                    'Trigger Condition Comorbidity',
                    '/risk-profiling-by-trigger',
                  ],
                  ['Cost Percentile', '/risk-profiling-by-cost'],
                  [
                    'High Cost Services Utilization',
                    '/risk-profiling-by-utilization',
                  ],
                  // ['Multiple Drug Consumption', '/risk-profiling'],
                ],
              ],
              ['Deep Dive', `/deep-dive`],
              ['Trend Analysis', `/trend-analysis`],
              ['Payment Integrity', `/payment-integrity`],
              ['CMS Benchmark', `/cms-benchmark`],
            ],
            '/dashboard',
          ],
          [
            'Contracts AIQ',
            true,
            [
              ['Plan Documents', `/plan-documents`],
              ['Contracts', '/contract'],
              // ['Playbooks & Standards', '/playbook'],
              // ['Compliance Reports', '/compliance-report'],
              ['Drafts', '/draft-agreements'],
              ['M & A Due Diligence', '/due-diligence'],
              ['Document Comparison', '/doc-comparison'],
              ['Proposal Analyzer', '/proposal-analyzer'],
            ],
            '/compliance-assurance',
          ],
          // [
          //   'Custom Analysis',
          //   true,
          //   [
          //     ['Custom Query Builder', `/custom-query-builder`],
          //     ['KPI Tracker', '/kpi-tracker'],
          //     [
          //       'Cohort Analysis',
          //       `/dashboard/${encodeURIComponent('Cohort Analysis')}`,
          //       [
          //         ['Chronic Condition Cohort', '/chronic-cohort-analysis'],
          //         [
          //           'Multiple Drugs Consumption Cohort',
          //           '/multiple-drug-cohort',
          //         ],
          //         ['High Cost Claimants Cohort', '/high-cost-cohort'],
          //       ],
          //     ],
          //   ],
          //   '/custom-analysis',
          // ],
          // ['Reports', false, '/reports'],
          [
            'Reports',
            true,
            [
              ['Compliance PDF Builder', '/compliance-report'],
              ['Claims Analysis PDF Builder', '/reports'],
            ],
            '/pdf-reports-builder',
          ],
          // [
          //   'Recommendations',
          //   true,
          //   [
          //     ['Claim Analysis', `/claim-analysis`],
          //     ['Contract Analysis', '/contract-risk-analysis'],
          //   ],
          //   '/recommendations',
          // ],
          ['Strategy & Insights Board', false, '/risk-register'],
          ['Task Board', false, '/task-board'],
          ['Data Sphere', false, '/data-catalogue'],
          ['Care Navigation', false, '/care-navigator'],
          ['AI Assistant', false, '/chat'],
          ['User Management', false, '/user-management'],
        ],
      },
      USER_MANAGEMENT: 'user-management',
    },
    LOGIN_ORAGNISM: {
      TITLE: ' Welcome to Homa',
      SUB_TITLE: 'Please enter your details to sign in to your account',
      EMAIL: 'Email',
      PASSWORD: 'Password',
      BUTTON: 'Login',
      GOOGLE_BUTTON: 'Sign in with google',
      FORGOT_PASSWORD: 'Forgot password?',
      PASSWORD_CREATED_SUCCESSFULLY: 'Password created successfully',
      PASSWORD_RESET_SUCCESSFULLY: 'Password reset successfully',
    },
    PATIENT_DETAILS_SIDE_CONTENT: {
      MEMBER_ID: 'Member ID - ',
      RISK_PATIENT_DETAILS: 'Risk Patient Details',
    },
    DISEASE_PREVALENCE_TABLE: {
      HEADERS: {
        DISEASE_CATEGORY: 'Disease Category',
        PREVALENCE_RATE: 'Prevalence Rate',
        TOTAL_COST: 'Total Cost',
        MEDICAL: 'Medical %',
        RX: 'Rx %',
        AVG_COST: 'A.C.P.M',
        PMPM: 'PMPM',
        HIGH_COST: 'Outlier',
        AVG_COST_TOOLTIP: 'Average Cost of Care Per Diagnosed Member',
        PMPM_TOOLTIP: 'Cost Of Care Per Member Per Month',
        HIGH_COST_TOOLTIP:
          'Cost of care for the highest costing diagnosed member',
      },
      REDIRECT_URL_DISEASE: 'https://www.icd10data.com/ICD10CM/Codes',
      REDIRECT_URL_CHRONIC:
        'https://www2.ccwdata.org/web/guest/condition-categories',
    },
    EPISODES_OF_CARE_TABLE: {
      HEADERS: {
        EPISODE_NAME: 'Episode Name',
        EPISODES: 'Episodes',
        TOTAL_COST: 'Total Cost',
        PERCENTILE_25: '25th Percentile',
        MEDIAN_COST: 'Median Cost',
        PERCENTILE_75: '75th Percentile',
      },
    },
    EPISODES_OF_CARE_SELECTED_TABLE: {
      HEADERS: {
        COST_TYPE: 'Cost Type',
        TOTAL_COST: 'Total Cost',
        PERCENTILE_25: '25th Percentile',
        MEDIAN_COST: 'Median Cost',
        PERCENTILE_75: '75th Percentile',
      },
    },
    EPISODES_OF_CARE_TOOLTIP: {
      TOOL_TIP: {
        PRE_OPERATIVE: 'Pre Operative ',
        POST_OPERATIVE: 'Post Operative ',
        EVENT_COST: 'Surgery Cost ',
      },
    },
    REPORTS_MODAL: {
      TITLE: 'Download Reports',
      SUBTITLE: 'Select the screens that you would like to view or download',
      VIEW_BUTTON: 'View Selected Report',
      DOWNLOAD_BUTTON: 'Download Selected Report',
      SNACKBAR_MESSAGES: {
        OPEN_REPORT: 'Report is being opened please wait...',
        DOWNLOAD_REPORT: 'Report is being downloaded please wait...',
        OPEN_SUCCESS: 'Report has been opened successfully',
        DONWLOAD_SUCCESS: 'Report has been downloaded successfully',
        API_ERROR: 'Something went wrong in API call please check',
      },
    },
    REPORTS_CREATE_NEW_MODAL: {
      SAVE: 'Save',
      UPDATE: 'Update',
      CANCEL: 'Cancel',
      ADD_COHORTS_INFO:
        'To finetune your data for the selected group(s) add cohorts by ',
      EDIT_COHORTS_INFO:
        'Edit the cohorts you selected previously for the group(s) by ',
      CLICK_HERE: 'clicking here',
      CREATE_NEW_DASHBOARD: {
        TITLE: 'Create New Dashboard',
        UPDATE_TITLE: 'Edit Dasboard',
        SUBTITLE: [
          [
            'Select the properties that you would like to apply to the report',
            {},
          ],
        ],
        DASHBOARD_NAME: 'Dashboard Name',
        DASHBOARD_PLACEHOLDER: 'Enter dashboard name',
        EMPLOYER_GROUPS: 'Employer Group(s)',
        EMPLOYER_GROUPS_PLACEHOLDER: 'Select one or more groups',
        COHORTS: {
          TITLE1: 'Add Cohort',
          TITLE2: 'Edit Cohort',
          SUB_TITLE:
            'Select the properties that you would like to apply to current data',
        },
      },
      CREATE_NEW_REPORT: {
        TITLE: 'Create New Report',
        UPDATE_TITLE: 'Update Report',
        SUBTITLE: [
          ['Select the ', {}],
          ['reports & groups ', SubtitleBoldTypographyProps],
          ['to view the ', {}],
          ['date & cohort ', SubtitleBoldTypographyProps],
          ['selections', {}],
        ],
        REPORT_NAME: 'Report Name',
        REPORT_PLACEHOLDER: 'Enter Report name',
        EMPLOYER_GROUPS: 'Employer Group(s)',
        SELECT_REPORTS: 'Select Report(s)',
        DOWNLOAD_FREQUENCY: 'Download Frequency',
        EMPLOYER_GROUPS_PLACEHOLDER: 'Select one or more groups',
        REPORTS_PLACEHOLDER: 'Select one or more reports',
        DOWNLOAD_FREQUENCY_INFO: {
          PART1: 'Your latest ',
          PART2: ' report with us is for the period ',
        },
        DROPDOWN_OPTIONS: [
          'Monthly',
          'Quarterly',
          'Half-Yearly',
          'Annually',
          'Custom',
        ],
        ANNUAL_DROPDOWN_OPTIONS: ['Annually', 'Custom'],
        DROPDOWN_DISPLAY_OPTIONS: [
          'Monthly',
          'Quarterly',
          'Half-Yearly',
          'Annually',
          'Custom One Time Download',
        ],
        ANNUAL_DROPDOWN_DISPLAY_OPTIONS: [
          'Annually',
          'Custom One Time Download',
        ],
      },
      ADD_COHORTS: '+ Add Cohort(s)',
      COHORT_DETAILS: 'Cohort Details -',
    },
    COHORT_DETAILS: {
      TITLE: 'Add Cohort',
      DETAILS: 'Cohort Details',
      SUB_TITLE:
        'Select the properties that you would like to apply to current data',
      COHORT_CATEGORY_SELECTION: {
        CATEGORY_DROPDOWN: {
          TITLE: 'Category',
        },
        PROPERTY_DROPDOWN: {
          TITLE: 'Property',
        },
        CONDITION_DROPDOWN: {
          TITLE: 'Condition',
        },
      },
      SAVE: 'Save',
      CANCEL: 'Cancel',
      RESET_FILTER: 'Clear Filter',
      ADD_COHORTS: '+ Add Cohort',
      PREVIEW_RESULTS: 'Preview Results',
      TOTAL_PATIENTS: 'Total No Of Patients',
      COHORT_DETAILS: {
        SELECT: 'Select',
        CATEGORY: 'Category',
        PROPERTY: 'Property',
        AND: 'AND',
        OR: 'OR',
        CONDITION: 'Condition',
        TEXT_FIELD_PLACEHOLDER: 'Enter Numerical Value',
        SAVE: 'Submit',
      },
    },
    RESET_PASSWORD: {
      ENTER_NEW_PASSWORD: 'Enter new password',
      CONFIRM_NEW_PASSWORD: 'Confirm new password',
      CONSTRAINTS_INFO: 'Your password must contain',
      CONSTRAINTS_SAME_PASS: 'Both passwords should match',
      CONSTRAINT1: 'a special character (@$!%*#?&)',
      CONSTRAINT2: 'a number (0-9)',
      CONSTRAINT3: 'an uppercase letter (A-Z)',
      CONSTRAINT4: 'a lowercase letter (a-z)',
      CONSTRAINT5: 'minimum 8 characters',
      CONSTRAINTS_SATISFIED: 'Your password is strong and safe to use',
      CREATE_PASSWORD: 'Create Password',
      RESET_PASSWORD: 'Reset Password',
      RESET_SUBTITLE: 'Reset your password for secure access',
      CREATE_SUBTITLE: `Let's get started by creating a password`,
      RESET_TITLE: 'Reset your Password',
      CREATE_TITLE: 'Welcome to Homa',
      ALREADY_REGISTERED: 'User Already Registered',
      PASSWORD_RESET: 'Password Already Set',
      FORGOT_PASSWORD_TITLE: 'Forgot your password?',
      OTP_VERIFICATION: 'OTP Verification',
      OTP_VERIFICATION_SUBTITLE: `A one-time password (OTP) has been sent to `,
      FORGOT_PASSWORD_SUBTITLE: `No worries, we’ll send you reset instructions`,
      GOTO_LOGIN: 'Go to login',
      EMAIL: 'Email',
      INVALID_EMAIL: 'Invalid email',
      SOMETHING_WENT_WRONG: 'Something went wrong, please contact support team',
      PASSWORDS_DONOT_MATCH: 'Passwords do not match, please try again',
      RESET_INSTRUCTIONS: {
        TITLE: 'Reset Instructions sent!',
        INFO1: 'If a Homa account exists for the email ',
        INFO2: ', instructions for resetting your password will be sent to it.',
        RECEIVE_EMAIL_INFO:
          'You’ll receive this email within 5 minutes. Be sure to check your spam folder too.',
      },
    },
    FEATURE_MODAL: {
      TITLE1: 'Page Under Construction',
      TITLE2: 'Feature not available for you',

      SUBTITLE1: {
        PART1:
          'Our team is hard at work creating this amazing feature for you. Check back soon ',
        PART2: 'for the big reveal!',
      },
      SUBTITLE2: {
        PART1:
          'This feature is currently unavailable for your access. Please contact our support',
        PART2: 'team at ',
        PART3: 'help@homahealth.us',
        PART4: ' for assistance on enabling this feature',
      },
      GO_BACK: 'Go back',
    },
    CUSTOM_QUERIES_TABLE: {
      TITLE: 'Custom Queries',
      SUBTITLE1: 'You can select the desired ',
      SUBTITLE2: ' type ',
      SUBTITLE3: ' and ',
      SUBTITLE4: ' cohorts ',
      SUBTITLE5: ' to build custom queries',
      CREATE_NEW: 'Create New',
      DOWNLOAD_SELECTED: 'Download selected',
      DELETE_SELECTED: 'Delete selected',
      EMPTY_DATA_MESSAGE: 'There are no custom queries built out yet',
    },
    EMAIL_SCHEDULER: {
      TITLE: 'Email Scheduler',
      DAY_LABEL: 'Day of the month',
      TIME_LABEL: 'Select Time',
      DATE_LABEL: 'Select Date',
      EMAILS: 'Email ID(s)',
      INFO_LABEL: {
        PART1: 'Your latest ',
        PART2: ' report will be delivered on ',
        PART3: ', at ',
      },
      DATE_PLACEHOLDER: '(MM-DD-YYYY)',
      TIME_PLACEHOLDER: '(HH:MM AM/PM)',
      EMAILS_PLACEHOLDER: 'Enter Email(s)',
      DAY_PLACEHOLDER: 'Day',
      CUSTOM_SELECTION_TOOLTIP: `Select the desired date, time and input the recipient's email addresses to schedule the report's delivery`,
      PERIODIC_SELECTION_TOOLTIP: `Select the desired start date, end date, time, day of the month, and input the recipient's email addresses to schedule the report's delivery`,
    },
    CREATE_NEW_QUERY_MODAL: {
      TITLE: {
        VIEW: 'View Custom Individual Group',
        SAVE: 'Create New Custom Query',
        UPDATE: 'Update Custom Query',
      },
      SUBTITLE: {
        VIEW: 'Customize your dashboard settings and include cohorts if needed',
        SAVE:
          'Enter your new dashboard details and also include any cohorts if necessary',
        UPDATE:
          'Update your dashboard details and also include any cohorts if necessary',
      },
      ADD_COHORTS_INFO:
        'To finetune your data for the selected group(s) add cohorts by ',
      EDIT_COHORTS_INFO:
        'Edit the cohorts you selected previously for the group(s) by ',
      CLICK_HERE: 'clicking here',
      SUBMIT_BUTTON: {
        VIEW: 'View',
        SAVE: 'Save',
        UPDATE: 'Update',
      },
      CANCEL: 'Cancel',
      COHORTS: {
        TITLE1: 'Add Cohort',
        TITLE2: 'Edit Cohort',
        SUB_TITLE:
          'Select the properties that you would like to apply to current data',
      },
      QUERY_NAME: 'Query Name',
      EMPLOYER_GROUPS: 'Employer Group(s)',
      EMPLOYER_GROUPS_PLACEHOLDER: 'Select one or more groups',
      TYPE: 'Type',
      FEATURES: 'Features',
      FEATURES_PLACEHOLDER: 'Select one or more features',
      DROPDOWN_OPTIONS: {
        Members: [
          'Member ID',
          'First Name',
          'Last Name',
          'Employee ID',
          'Member Relationship',
          'Date Of Birth',
          'Gender',
          'Age',
          'Recent Visit',
          'State',
          'Zip Code',
          'Cost',
          'Medical Cost',
          'Rx Cost',
          'Highest Costing Claim',
          'Previous Year Cost',
          'Claim Count',
          'RAF',
          'Chronic Conditions',
          'Trigger Conditions',
          'ED Visits',
          'RAF',
          'Adherence Rate',
          'DDI',
          'DDI Drugs',
          'Non-Compliant Care Measures',
        ],
        Claims: [
          'Claim ID',
          'Member ID',
          'Date',
          'Claim Type',
          'Admission Flag',
          'NDC',
          'Place of Service',
          'Rev Code',
          'Provider',
          'Network Status',
          'Pharmacy',
          'Pharmacy Address',
          'Pharmacy Number',
          'Drug',
          'Total Billed Amount',
          'Total Paid Amount',
          'Medication',
          'Type Of Service',
          'Primary Diagnosis',
          'Trigger Condition',
          'Chronic Condition',
          'Lifestyle Condition',
          'Provider Address',
          'Provider Speciality',
          'Place of Service',
          'Claim DRG',
          'Member ID',
          'First Name',
          'Last Name',
          'Employee ID',
          'Member Relationship',
          'Date Of Birth',
          'Gender',
          'Age',
          'Level of Coverage',
          'Waste Group',
          'Waste Description',
        ],
      },
      DOWNLOAD_FREQUENCY: 'Download Frequency',
      DOWNLOAD_FREQUENCY_OPTIONS: [
        'Monthly',
        'Quarterly',
        'Half-Yearly',
        'Annually',
        'Custom',
      ],
    },
    CLAUSE_DETAILS: {
      TITLE: 'Analysis of Clause:',
      EVALUATION: 'Evaluation',
      LIST_VIEW: 'Check off list',

      FULLY_MET: 'Fully Met',
      UNMET: 'Not Met',
      TOTAL: 'Total',
      EVALUATION_TOOLTIP:
        'These are the parameters which specify the answers to that question of checkoff list. Customize the response',
    },
    FILE_UPLOADER_MODAL: {
      TITLE: 'UPLOAD CONTRACTS',
      SUBTITLE: 'Upload Contracts to start analyzing, Max File Size: 50mb',
    },
    ADD_GROUP_POPUP: {
      TITLE: 'Group Details',
      GROUP_FIELD: 'Group Name*',
      GROUP_LABEL: 'Select Group',
      TEXT_FIELDS: [
        'Claims Administrator',
        'PBM',
        'Stop loss carrier',
        'Network Carrier',
        'Broker/ Advisor/ Consultant',
      ],
      SAVE_BUTTON: 'Save',
      ON_BOARDING_BUTTON: 'Start Onboarding',
      UPDATE_BUTTON: 'Update',
    },
    CARE_NAV_MODALS: {
      ASSIGN_MODAL: {
        ASSIGN_TITLE: 'Assign Care Navigator',
        REPLACE_TITLE: 'Replace Care Navigator',
        SELECT_ROLE: 'Select Role',
        roleOptions: ['Nurse', 'Pharmacist', 'Customer Service'],
        roleValues: [
          'care_navigator_nurse',
          'care_navigator_pharmacist',
          'care_navigator_customer_service',
        ],
        SELECT_CARE_NAV: 'Select Care Navigator',
        SUBMIT: 'Create Case & Assign',
        UPDATE: 'Replace & Assign',
        CANCEL: 'Cancel',
        SELF_ASSIGN: 'Self Assign & Accept Case',
        ADD_NOTE: 'Add Note (Optional)',
        ROLE_OPTIONS: ['Nurse', 'Pharmacist'],
      },
      ACCEPT_MODAL: {
        TITLE: 'Start/Accept New Case',
        SUB_TITLE: 'Do you want to continue with Start New Case?',
        SUBMIT: 'Accept Case',
        CANCEL: 'Cancel',
      },
      DELETE_GROUP_CONFIRM_MODAL: {
        TITLE: 'Delete Group',
        SUB_TITLE1: 'On confirmation, ',
        SUB_TITLE2: ' will be deleted permanently.',
        SUB_TITLE3: 'Are you sure?',
        SUB_TITLE4: 'Related interactions will also be deleted.',
        SUBMIT: 'Confirm',
        CANCEL: 'Cancel',
      },
      ADD_CATEGORY_MODAL: {
        TITLE: 'Add To Member Of Interest',
        SUB_TITLE: 'Add the category for member of interest.',
        CATEGORY: 'Category',
        SUBMIT: 'Submit',
        CANCEL: 'Cancel',
      },
      CREATE_CARE_NAV_MODAL: {
        ADD_TITLE: 'Add Care Navigator',
        ADD_DESC: 'Add details for the new care navigator',
        EDIT_TITLE: 'Edit Care Navigator',
        EDIT_DESC: 'Edit details for the care navigator',
        SUBMIT: 'Submit',
        UPDATE: 'Update',
        CANCEL: 'Cancel',
        FIRSTNAME: 'FirstName',
        LASTNAME: 'LastName',
        ROLE: 'Role',
        roleOptions: ['Nurse', 'Pharmacist', 'Customer Service'],
        roleValues: [
          'care_navigator_nurse',
          'care_navigator_pharmacist',
          'care_navigator_customer_service',
        ],
        EMAIL: 'E-Mail',
        CONTACT: 'Contact',
        EXPERIENCE: 'Experience',
        GROUP: 'Group',
        FEATURES: 'Features',
        SPECIALITY: 'Speciality',
        SELECTFEATURE: 'Select Feature(s)',
      },
      ADD_MEMBER: {
        TITLE: 'Add New Member',
        SUB_TITLE:
          'Select the properties that you would like to apply to the member',
        NAME: 'Patient Name',
        AGE: 'Age',
        GENDER: 'Gender',
        ENROLLMENT: 'Enrollment Status',
        CONDITION: 'Enter Condition',
        CANCEL: 'Cancel',
        SUBMIT: 'Submit',
      },
      ENDCASE_MODAL: {
        TITLE: 'Case Survey Report',
        SUBMIT: 'Submit',
        NEXT: 'Submit & Next',
        UPDATE: 'Update',
        UPDATE_NEXT: 'Update & Next',
        CANCEL: 'Cancel',
        TAB_STEPS: ['Care Navigator Survey', 'Member Survey'],
        CASE_TYPE: 'Case Type',
        REFERRAL: 'Partner Referral',
        SAVINGS_IMPACT: 'Savings Impact (In Dollars)',
        ROI: 'ROI (In Dollars)',
        MEMBER_RESPONSIVENESS: 'Member Responsiveness',
        RESPONSIVENESS_OPTIONS: ['Very Good', 'Good', 'Not Responsive'],
        TYPE_HERE: 'Type Here...',
        FEEDBACK: 'Share your review or feedbacks here..',
        RATING: 'Ratings & Review',
      },
      ADD_INTERACTION: {
        TITLE: 'Add New Interaction',
        UPDATE_TITLE: 'Update Interaction',
        SUB_TITLE:
          'Select the properties that you would like to apply to the interaction',
        TYPE: 'Type Of Interaction',
        TYPE_OPTIONS: ['Inbound', 'Outbound'],
        MODE: 'Mode Of Interaction',
        MODE_OPTIONS: [
          'On Call',
          'Video Call',
          'In Person',
          'Emails',
          'On Text',
        ],
        REFERRAL: 'Add Referral',
        DATE: 'Date',
        DETAILS: 'Add Case Details',
        CANCEL: 'Cancel',
        SUBMIT: 'Submit',
        UPDATE: 'Update',
      },
      ADD_GROUP: {
        TITLE: 'Add New Group',
        SUB_TITLE:
          'Enter group name and upload member census files for new group',
        GROUP: 'Enter Group Name',
        CANCEL: 'Cancel',
        SUBMIT: 'Submit',
        GROUP_LABEL: 'Enter group',
      },
      MEMBER_OF_INTEREST: {
        TITLE: 'Start Case',
        SUB_TITLE:
          'Select the properties that you would like to apply to the case',
        NAME: 'Patient Name',
        GROUP: 'Select Group',
        PRIORITY: 'Priority',
        ENGAGEMENT: 'Last Engagement',
        TRIGGER: 'Type of Trigger',
        CANCEL: 'Cancel',
        SUBMIT: 'Submit',
        selfAssign: 'Self Assign & Accept',
        addInteraction: 'Add Interaction',
        closeCase: 'Close Case',
      },
    },
  },
  PAGES: {
    PATIENT_DETAILS_PAGE: {
      SEARCH_HISTORY: 'Search History',
    },
    USER_MANAGEMENT_PAGE: {
      USER_MANAGEMENT: 'User Management',
      SHOWING_DATA1: 'You can add or edit a desired on this section',
      SHOWING_DATA2: 'user',
      OTHER_ACTIONS: 'Other Actions',
      ADD_MEMBERS: 'CREATE NEW',
      DELETE_SELECTED: 'Delete selected',
      DELETE_CONFIRMATION_TITLE:
        'Are you sure you want to delete this user account?',
      DELETE_CONFIRMATION_SUBTITLE:
        ' Once a user account is deleted it cannot be bought back',
      CONFIRM_DELETE: 'Confirm Delete',
    },
    CLAIM_METRICS_PAGE: {
      TITLE: 'Claims Metrics',
      SUBTITLE: 'Breakdown of all charges by plan, member and network',
      DOWNLOAD: 'Download',
      QUERY_DATA: 'Query Data',
      OVERVIEW_CARDS: {
        TOTAL_ELIGIBLE: 'Total Eligible',
        TOTAL_ENROLLED: 'Total Enrolled',
        TOTAL_COST: 'Total Cost',
        PMPM: 'PMPM',
        PEPM: 'PEPM',
      },
      TABLES: {
        TABLE1_TITLE: 'Top Plan Paid Impact',
        TABLE1_TITLE2: 'Plan Paid by Category',
        TABLE1_SUBTITLE:
          'The table displays the highest contributor to the plan paid amount in different categories',
        TABLE1_COLUMNS: ['Category', 'Plan Impact', 'Plan Paid'],
        TABLE2_TITLE: 'Top Member Paid Impact',
        TABLE2_SUBTITLE:
          'The table displays the highest contributor to the member paid amount in different categories',
        TABLE2_COLUMNS: ['Category', 'Member Impact', 'Member Paid'],
      },
    },
    PLAN_PERFORMANCE_METRICS_PAGE: {
      TITLE: 'Plan Performance',
      SUBTITLE:
        'Showing employer claims data from January 2022 to December 2022.',
      DOWNLOAD: 'Download',
      QUERY_DATA: 'Query Data',
      OVERVIEW_CARDS: {
        TOTAL_ELIGIBLE: 'Total Eligible',
        TOTAL_ENROLLED: 'Total Enrolled',
        TOTAL_PLAN_COST: 'Total Plan Cost',
        TOTAL_COST: 'Total Cost of Care',
        PMPM: 'PMPM',
        PEPM: 'PEPM',
      },
      COST_TREND: {
        TITLE: 'Cost Trend by Month',
        SUB_TITLE:
          'Showing plan cost trend by month and cumulative cost for the selective period. To see more about cost trend',
      },
    },
    UTILIZATION_SUMMARY_PAGE: {
      TITLE: 'Utilization Summary',
      SUBTITLE:
        'High-level overview of the service and drug types consumed by plan members.',
      DOWNLOAD: 'Download',
      QUERY_DATA: 'Query Data',
      OVERVIEW: 'Overview',
      RECOMMENDATIONS: 'Recommendations',
      OVERVIEW_CARDS: {
        MEMBERS: 'Members',
        TOTAL_COST: 'Total Cost',
        PMPM: 'PMPM',
        PEPM: 'PEPM',
      },
      TABLES: {
        TABLE1_TITLE: 'Top Plan Paid Impact',
        TABLE1_SUBTITLE:
          'The table displays the highest contributor to the plan paid amount in different categories',
        TABLE1_COLUMNS: ['Category', 'Plan Impact', 'Plan Paid'],
        TABLE2_TITLE: 'Top Member Paid Impact',
        TABLE2_SUBTITLE:
          'The table displays the highest contributor to the member paid amount in different categories',
        TABLE2_COLUMNS: ['Category', 'Member Impact', 'Member Paid'],
      },
      UTILIZATION: 'Utilization',
      CLICK_HERE: 'Click Here',
      RX_CARD: {
        TITLE: 'Pharmacy Utilization',
        SUBTITLE: 'To see more about the utilization ',
        LABELS: ['Total Pharmacy Cost', 'Pharmacy PMPM'],
        RATIO_DATA_LABELS: ['Branded', 'Generic'],
      },
      PROCEDURE_CARD: {
        TITLE: 'Procedure Utilization',
        SUBTITLE: 'To see more about the utilization ',
        LABELS: ['Total Cost', 'Procedure PMPM'],
        RATIO_DATA_LABELS: ['Surgical', 'Non Surgical'],
      },
      MEDICAL_SERVICES_CARD: {
        TITLE: 'Medical Services Utilization',
        SUBTITLE: 'To see more about the utilization ',
        LABELS: ['Total Cost', 'Medical PMPM'],
        RATIO_DATA_LABELS: ['Inpatient', 'Others'],
      },
      NETWORK_PROVIDER_CARD: {
        TITLE: 'Network Provider Utilization',
        SUBTITLE: 'To see more about the utilization ',
        LABELS: [],
        RATIO_DATA_LABELS: {
          LABELS1: ['Physician In-Network', 'Physician Out-of-Network'],
          LABELS2: ['Facility In-Network', 'Facility Out-of-Network'],
        },
      },
      PROVIDER_UTILIZATION: 'Provider Utilization',
      ADMISSION_UTLIZATION: 'Admission Utilization',
    },
    HOMEPAGE_CHIPS: {
      HIGH_RISK: 'High Risk',
      NEEDS_ATTENTION: 'Needs Attention',
      MEDIUM_RISK: 'Medium Risk',
      LOW_RISK: 'Low Risk',
      RELATIVELY_HEALTHY: 'Relatively Healthy',
    },
    UTILIZATION_RX: {
      ALL_DRUGS: 'All Drugs',
      DRUG_TYPES: {
        MEDPHARMA: 'Medpharma',
        SPECIALITY: 'Speciality Drug',
        OTHER: 'Non-Speciality Drug',
      },
      TOP_DRUGS_TABLE: {
        TITLE: 'Top Drugs by',
        TITLE1: 'Top Drugs',
        SUBTITLE:
          'You can view the drugs in different categories of Medpharma, Specialty and Non-Speciality by clicking on the dropdown',
        DROPDOWN_DISPLAY_VALUES: [
          'All Drugs',
          'Medpharma',
          'Specialty',
          'Non Speciality',
        ],
        DROPDOWN_VALUES: [
          'All Drugs',
          'Medpharma',
          'Speciality Drug',
          'Non-Speciality Drug',
        ],
      },
      MAIN_SORT_COLUMN: 'totalCost',
      MAIN_SORT_ORDER: -1,
    },
    HOME_PAGE: {
      INDIVIDUAL_GROUPS: 'Individual Groups',
      CUSTOM_DASHBOARDS: 'Custom Rollup/Drilldown Dashboards',
      CUSTOM_REPORTS: 'Custom Rollup/Drilldown Reports',
      CARD_SUBTITLE: 'Click on a group to view the dashboards',
      CUSTOM_DASHBOARDS_SUBTITLE: {
        PART1: 'You can select the ',
        PART2: ' groups, desired cohort',
        PART3: ' and ',
        PART4: 'plan period',
        PART5: ' to see custom dashboards',
      },
      SEARCH: 'Search',
      TABS: ['Claims AIQ', 'Contracts AIQ', 'Care Navigation'],
      CUSTOM_DASHBOARDS_EMPTY:
        'There are no custom rollup/drilldown dashboards built out yet',
      DASHBOARD_FEATURES: [
        'SUMMARY',
        'DISEASE_MANAGEMENT',
        'FISCAL_CONTROL',
        'COST_MANAGEMENT',
        'STOP_LOSS_MANAGEMENT',
        'PLAN_ANALYSIS',
        'CLAIMS_MANAGEMENT',
        'MEDICAL_CLAIM_UTILIZATION',
        'DRUG_UTILIZATION',
        'RISK_PROFILE',
        'DATA_CATALOGUE',
        'DEEP_DIVE',
        'TREND_ANALYSIS',
        'COHORT_COMPARISON',
      ],
    },
    REPORTS: {
      REPORTS: 'Reports',
      SUBTITLE:
        'Generate and schedule automated analytical reports on key healthcare and financial metrics for strategic insights and decision-making.',
      DOWNLOAD_SELECTED: 'Download Selected',
      DOWNLOAD_ALL: 'Download All',
      CREATE_NEW: 'Create New',
      REPORTS_TABLE_SUBTITLE:
        'Click on a section to view/download the individual reports',
      REGULATORY_REPORTS: 'Regulatory Reports',
      REGULATORY_REPORTS_TABLE_SUBTITLE:
        'Click on a section to view/download the individual reports',
      CUSTOM_REPORTS: {
        TITLE: 'Custom Rollup/Drilldown Reports',
        SUBTITLE: {
          PART1: 'You can select the  ',
          PART2: 'groups, desired cohort',
          PART3: ' and ',
          PART4: 'plan period',
          PART5: ' when you download a report',
        },
        DOWNLOAD_SELECTED: 'Download selected',
        DELETE_SELECTED: 'Delete selected',
        EMPTY_DATA_MESSAGE:
          'There are no custom rollup/drilldown reports built out yet',

        QUATERLY_TITLE: 'Custom Reports',
      },
      MODAL: {
        TITLE: {
          DOWNLOAD_ALL: 'Download all reports',
          DOWNLOAD_SELECTED: 'Download Selected report(s)',
        },
        SUBTITLE: 'Select the plan period for the report(s) to be downloaded',
        CANCEL: 'Cancel',
        DOWNLOAD: 'Download',
      },
    },
    PHARMACY_SPEND_PAGES: {
      TOP_DRUGS: 'Top Drugs',
      TOP_DRUGS_SUBTITLE: 'You can view the drugs in Medpharma catrgory',
      DRUG_CATEGORIES_CANCER_TITLE: 'Drug Categories: Cancer Diagnosis',
      DRUG_CATEGORIES_CANCER_SUBTITLE:
        'Showing cost distribution in different categories of drugs prescribed for cancer diagnosis',
      DRUG_CATEGORIES_NON_CANCER_TITLE: 'Drug Categories: Non-Cancer Diagnosis',
      DRUG_CATEGORIES_NON_CANCER_SUBTITLE:
        'Showing cost distribution in different categories of drugs prescribed for non-cancer diagnosis',
      MAIN_SORT_COLUMN: 'totalCost',
      MAIN_SORT_ORDER: -1,
    },
    ERROR_PAGE: {
      PAGE_NOT_FOUND: 'Page Not Found',
      INFO:
        "We're sorry, the page you're looking for can't be found. Please try reloading the page or contact our support team for assistance",
      RELOAD: 'Reload Page',
      GO_BACK: 'Go back',
      LOGIN_PAGE: 'Back to login',
    },
    CONTRACT_REPORT_PAGE: {
      CHIP_VALUES: {
        HIGH: 'High Risk',
        LOW: 'Low Risk',
        MEDIUM: 'Medium Risk',
      },
      PAGE_DATA: {
        data: [
          {
            _id: '65f1b24c4668fad59d0a916e',
            service_agreement_id: '3500_01_01',
            standard_id: 'Transparency',
            clause_id: 1,
            clause_name: 'Reporting Requirements',
            risk_category: 'Low',
            aim_of_the_clause:
              "The clause outlines the PBM's obligations to provide:Standard management, utilization, and detailed claims reports at no additional cost, with fees for non-standard reports.Quarterly reconciliation statements on rebate guarantees and exclusions, plus pharmacy fee shares.Semi-annual reports on top drugs by spend and utilization, including financial breakdowns and differentiation between PBM-owned and non-PBM-owned pharmacies.",
            analysis:
              'The Contract provides a comprehensive framework for the services to be rendered by PBM, including management and utilization reports, routine claims invoices, and detailed claims data. It also specifies the provision of electronic reconciliation statements for rebates and the reporting of fees paid by pharmacies. The Contract allows for the availability of non-standard and ad hoc reports with an agreed-upon fee arrangement and commits to supplying reporting to the Clients designee with confidentiality and HIPAA protections. Semi-annual reporting of the top 25 drugs by spend and utilization is included, as well as reporting for specialty drugs conversion. However, the Contract does not explicitly mention the provision of rationale for each claim in cases of no minimum rebate guarantee, nor does it explicitly state the reporting of the Clients share of fees related to missed quality metrics.',
            check_off_list_id: [
              {
                category:
                  'Will PBM provide standard management and utilization reports as described in the contract?',
                flag: 'Yes',
              },
              {
                category:
                  'Will routine Claims invoices be issued by PBM, including a defined set of Claims data at no additional charge?',
                flag: 'Yes',
              },
              {
                category:
                  'Will Claims data include, but not be limited to, patient and prescriber identifiers, diagnosis, date of prescription, and drug cost details?',
                flag: 'Yes',
              },
              {
                category:
                  'Will PBM submit an electronic reconciliation statement quarterly detailing Rebate amounts and actual paid Rebates per claim?',
                flag: 'Yes',
              },
              {
                category:
                  'In cases of no minimum Rebate guarantee, will PBM provide rationale for each claim?',
                flag: 'No',
              },
              {
                category:
                  'Will PBM report the Clients share of fees paid by pharmacies related to missed quality metrics and other assessed fees?',
                flag: 'No',
              },
              {
                category:
                  'Can non-standard and ad hoc reports be available with an agreed-upon fee arrangement?',
                flag: 'Yes',
              },
              {
                category:
                  'Upon Clients instruction, will PBM supply reporting to Clients designee subject to confidentiality and HIPAA protections?',
                flag: 'Yes',
              },
              {
                category:
                  'Will PBM report semi-annually the top 25 drugs by total spend and utilization, including plan sponsor and member paid amounts, and Rebate revenue per drug?',
                flag: 'Yes',
              },
              {
                category:
                  'For specialty drugs permitted for conversion from 30 days to 60 or 90 days, will PBM report the drug name and paid amounts?',
                flag: 'Yes',
              },
            ],
            score: 80,
          },
          {
            _id: '65f1b24c4668fad59d0a9171',
            service_agreement_id: '3500_01_01',
            standard_id: 'Customization',
            clause_id: 1,
            clause_name: 'PBM services',
            risk_category: 'High',
            aim_of_the_clause:
              'The clause aims to outline customizable PBM services based on client needs, including pharmacy network, drug selection, formulary development, and clinical management. It offers flexibility for these services to be modified or excluded as desired.',
            analysis:
              "The contract provides a comprehensive outline of the services to be provided by the PBM, including claims processing, eligibility verification, and pharmacy network management. It specifies the administrative and additional fees, details the performance guarantees, and includes provisions for confidentiality and HIPAA compliance. However, the contract does not explicitly define the client's authority to selectively remove services or parts of the contract ('carve-out'), nor does it specify examples of 'carve-out' eligible services. There is no clear provision or process outlined for altering the scope of services upon client request, and guidelines or implications for 'carving out' services, like cost or service adjustments, are not discussed. Additionally, the contract does not detail how additional services can be integrated into the agreement in the future.",
            check_off_list_id: [
              {
                category:
                  'Does the contract clearly enumerate the PBM services included?',
                flag: 'Yes',
              },
              {
                category:
                  "Is the client's authority to selectively remove services or parts of the contract ('carve-out') explicitly defined?",
                flag: 'No',
              },
              {
                category:
                  "Are examples of 'carve-out' eligible services, such as pharmacy network management and formulary development, specified?",
                flag: 'No',
              },
              {
                category:
                  'Is there a provision or process outlined for altering the scope of services under the contract upon client request?',
                flag: 'No',
              },
              {
                category:
                  "Are any guidelines or implications for 'carving out' services, like cost or service adjustments, discussed?",
                flag: 'No',
              },
              {
                category:
                  'Does the contract detail how additional services can be integrated into the agreement in the future?',
                flag: 'No',
              },
            ],
            score: 85,
          },
          {
            _id: '65f1b24c4668fad59d0a9178',
            service_agreement_id: '3500_01_01',
            standard_id: 'Client Satisfaction',
            clause_id: 1,
            clause_name: 'Account Management',
            risk_category: 'Low',
            aim_of_the_clause:
              'This clause details the account management services provided by the Pharmacy Benefit Manager (PBM) to the client, ensuring effective communication and support. Key points include:Account Management Team: The PBM assigns a designated team comprising an operational manager for day-to-day matters and a strategic advisor for innovative solutions.Responsibilities: The account team ensures timely provision of routine and ad hoc reporting as per the contract. This includes updates on formularies, MAC lists, prior authorization (PA) drug lists, specialty drug lists, non-covered drug lists, new drug launches, upcoming pipelines, and pharmacy network lists.',
            analysis:
              'The contract provides a comprehensive framework for the services to be rendered by the PBM, including the provision of a designated account management team, routine and ad hoc reporting, timely updates for formulary changes, notification of MAC list changes, updates on the PA Drug list, Specialty drug list, and a list of non-covered drugs. It also includes obligations for new drug launches, pharmacy network lists, and designated account management team responsibilities. However, the contract does not explicitly mention the provision of a strategic advisor for consulting on new solutions and approaches, nor does it explicitly state the requirement for the PBM to inform the Client about upcoming drug pipelines.',
            check_off_list_id: [
              {
                category:
                  'Designated account management team to ensure continuity of PBM Services',
                flag: 'Yes',
              },
              {
                category:
                  'Team includes at least one operational manager and one strategic advisor',
                flag: 'No',
              },
              {
                category:
                  'Account team responsible for routine and ad hoc reporting',
                flag: 'Yes',
              },
              {
                category: 'Timely updates for Formulary changes to the Client',
                flag: 'Yes',
              },
              {
                category: 'Notification of MAC list changes in a timely manner',
                flag: 'Yes',
              },
              {
                category: 'Updates on the PA Drug list as changes occur',
                flag: 'Yes',
              },
              {
                category:
                  'Inform the Client about updates to the Specialty drug list',
                flag: 'Yes',
              },
              {
                category:
                  'Provide a list of non-covered drugs and any updates to it',
                flag: 'Yes',
              },
              {
                category:
                  'Notify the Client about new drug launches and upcoming pipelines',
                flag: 'No',
              },
              {
                category:
                  'Required to provide the Client with pharmacy network lists and any changes',
                flag: 'Yes',
              },
            ],
            score: 75,
          },
          {
            _id: '65f1b24c4668fad59d0a917c',
            service_agreement_id: '3500_01_01',
            standard_id: 'Contractual Obligations and Responsibilities',
            clause_id: 1,
            clause_name: 'Preface',
            risk_category: 'Low',
            aim_of_the_clause:
              "The clause outlines the PBM's obligations to provide:Standard management, utilization, and detailed claims reports at no additional cost, with fees for non-standard reports.Quarterly reconciliation statements on rebate guarantees and exclusions, plus pharmacy fee shares.Semi-annual reports on top drugs by spend and utilization, including financial breakdowns and differentiation between PBM-owned and non-PBM-owned pharmacies.",
            analysis:
              "The Contract meets most of the standards set forth. It clearly identifies the parties involved and the effective date. The Sponsor's intention to offer cost-effective prescription benefit services is stated. The agreement confirms PBM's engagement with Participating Pharmacies to provide prescription benefit services. The scope of PBM services is outlined, including prescription claims processing, eligibility verification, and negotiation for favorable pricing. The agreement stipulates that PBM will perform services on a fully transparent basis, with access for the Sponsor to verify compliance and pricing. However, the mutual promises and agreements for satisfying the terms of the agreement are not clearly articulated in the provided sections of the Contract.",
            check_off_list_id: [
              {
                category: 'Identification of parties and effective date',
                flag: 'Yes',
              },
              {
                category:
                  "Sponsor's intention to offer cost-effective services",
                flag: 'Yes',
              },
              {
                category:
                  "Confirmation of PBM's engagement with Participating Pharmacies",
                flag: 'Yes',
              },
              {
                category: 'Outline of PBM services',
                flag: 'Yes',
              },
              {
                category: 'Transparent basis of PBM services',
                flag: 'Yes',
              },
              {
                category:
                  'Articulation of mutual promises for satisfying agreement terms',
                flag: 'No',
              },
            ],
            score: 80,
          },
        ],
        status: 'success',
      },
    },
    PROFILE_PAGE: {
      TITLE: 'User Profile',
      SUBTITLE: 'You can find User Details Here',

      SUPER_ADMIN: 'Super Admin',
      ADMIN: 'Admin',
      USER: 'User',

      CANCEL: 'Cancel',
      SUBMIT: 'SAVE',

      riskManagement: 'Claims AIQ',
      memberLives: 'Member Lives',
      complianceAssurance: 'Contracts AIQ',
      docUnits: 'Doc Units',
      careNavigation: 'Care Navigation',
      cases: 'Cases/Month',
    },
  },
};

export default componentConstants;
